import {CanDeactivateFn} from '@angular/router';
import {inject} from '@angular/core';
import {CategoryService} from '../category.service';
import {StoryService} from '../story.service';
import {PointOfInterestService} from '../point-of-interest.service';
import {RouteService} from '../route.service';
import {EventService} from '../event.service';
import {GoldenTipService} from '../golden-tip.service';
import {PlatformService} from '../platform.service';
import {Network} from '@capacitor/network';

export const resetServicesAfterShowGuard: CanDeactivateFn<boolean> = () => {
  const platformService = inject(PlatformService);
  if (platformService.isServer()) {
    inject(CategoryService).resetData();
    inject(RouteService).resetData();
    inject(StoryService).resetData();
    inject(PointOfInterestService).resetData();
    inject(EventService).resetData();
    inject(GoldenTipService).resetData();
    return true;
  }
  if (platformService.isNative()) {
    Network.getStatus().then((status) => {
      if (status.connected) {
        inject(CategoryService).resetData();
        inject(RouteService).resetData();
        inject(StoryService).resetData();
        inject(PointOfInterestService).resetData();
        inject(EventService).resetData();
        inject(GoldenTipService).resetData();
      }
    });
  } else if (navigator.onLine) {
    inject(CategoryService).resetData();
    inject(RouteService).resetData();
    inject(StoryService).resetData();
    inject(PointOfInterestService).resetData();
    inject(EventService).resetData();
    inject(GoldenTipService).resetData();
  }

  return true;
};
